import { useDynamicDialog } from '~/composables/dynamic-dialog';
import type { PurchaseLicenseModalData } from '~/types/licenses/licenses';
import { ModalNames } from '~/types/modals';

export function useSubscriptionHelper() {
  function subscribe(data: PurchaseLicenseModalData) {
    useDynamicDialog(ModalNames.PURCHASE_LICENSES, data)
  }

  return {
    subscribe,
  };
} 